import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Error } from '@bilancio/api';
import { sendPracticeTsbsEndpoint } from 'projects/bilancio/api/src/lib/deposit/endpoints/send-practice-tsbs.endpoint';
import { validatePracticeTsbsEndpoint } from 'projects/bilancio/api/src/lib/deposit/endpoints/validate-practice-tsbs.endpoint';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorSandbox } from '../service/error.sandbox';

@Injectable({ providedIn: 'root' })
export class ForbiddenMessageInterceptor implements HttpInterceptor {
  // Endpoints that should handle 401 errors themselves (not navigate to error page)
  private readonly skipUrls = [validatePracticeTsbsEndpoint(), sendPracticeTsbsEndpoint()];

  constructor(private readonly injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Skip error page navigation for specific endpoints that handle 401 themselves
          const shouldSkip = this.skipUrls.some(url => request.url.includes(url));

          if (!shouldSkip) {
            const sandbox = this.injector.get(ErrorSandbox);
            const errorObj: Error.ErrorObj = {
              errorCode: 401,
              errorMessage: sandbox.getMessage(error.status),
              errorBoldMsg: sandbox.getBoldMessage(error.status),
              errorStack: JSON.stringify(error),
              errorImg: sandbox.getImage(error.status),
              errorDate: new Date(),
            };
            sandbox.manageError(errorObj);
          }
        }

        throw error;
      }),
    );
  }
}
